module.exports = __webpack_public_path__ + "assets/scoober_tag-906811.svg";